import { AxiosResponse } from "axios";
import { UserGroupFilterRequest } from "@/main/models/request/";
import { Result } from "@/main/models/common/resultResponse";
import { UsergroupResponse } from "@/main/models/response";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

export abstract class IUsergroupApi {
	abstract getSearchGrid(
		request: UserGroupFilterRequest,
	): Promise<AxiosResponse<PaginationResponse<UsergroupResponse>>>;

	abstract changeStatusUserGroup(request: UserGroupFilterRequest): Promise<AxiosResponse<Result<void>>>;
}
